import { useRef } from 'react'

import NotificationManager from '../common/components/Notifications/NotificationManager'
import { Button } from '../common/components/button'
import { TextInput } from '../common/components/text-input'
import { ItemCard } from '../common/components/item-card'

import { useStyles } from './rmarkdown-empty-state.style'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faRefresh, faCopy } from '@fortawesome/pro-solid-svg-icons'

export const RmarkdownEmptyState = function ({ report, onRefresh }) {
  const classes = useStyles()

  const reportIdInputFieldRef = useRef()

  function copyIdToClipboard () {
    navigator.clipboard.writeText(reportIdInputFieldRef.current.value)
    NotificationManager.create({ type: 'success', timeOut: 10000, message: 'The report ID has been copied to your clipboard.' })
  }

  return (
    <ItemCard className={classes.card}>
      <div className="flex-column flex-center-items">
        <div className="card-title">📦 Rmarkdown</div>
        <div className={classes.cardText}>Have a static rmarkdown generated report? Use this ID to upload your report.</div>
        <div className="flex-row">
          <TextInput className={classes.reportIdInput} readOnly value={report.alias || report.id} data-qa="report-id-field"
            _ref={reportIdInputFieldRef} enableFocusAnimation={false} />
          <Button type="button" variant="icon-secondary" onClick={copyIdToClipboard}
            className={classes.copyAndRefreshButton} tooltipLabel="Copy Report ID"><FontAwesomeIcon icon={faCopy}/></Button>

          <Button type="button" variant="icon-secondary" onClick={onRefresh}
            data-qa="view-report-refresh" className={classes.copyAndRefreshButton} tooltipLabel="Refresh Page"><FontAwesomeIcon icon={faRefresh}/></Button>
        </div>
      </div>
    </ItemCard>
  )
}
